import React from 'react';


const LogOutIcon = (props) => {
    return (

            <svg width="25px" height="25px" className={`lg:${props.hidden}`} viewBox="-8 0 493 493" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h323v459h-323zm0 0" fill="#5a6470"/><path d="m255 493-255-34v-459l255 34zm0 0" fill="#2186EB"/><path d="m221 246.5c0 9.390625-7.609375 17-17 17s-17-7.609375-17-17 7.609375-17 17-17 17 7.609375 17 17zm0 0" fill="#2186EB"/><path d="m204 272c-14.082031 0-25.5-11.417969-25.5-25.5s11.417969-25.5 25.5-25.5 25.5 11.417969 25.5 25.5c-.015625 14.078125-11.421875 25.484375-25.5 25.5zm0-34c-4.695312 0-8.5 3.804688-8.5 8.5s3.804688 8.5 8.5 8.5 8.5-3.804688 8.5-8.5c-.003906-4.691406-3.808594-8.496094-8.5-8.5zm0 0" fill="#fcf05a"/><path d="m476 153-85-59.5v25.5h-102v68h102v25.5zm0 0" fill="#841003"/><path d="m187 102-119-17v-34l119 17zm0 0" fill="#fff"/></svg>

    );
};

export default LogOutIcon;